import BoardMembersOutline from '@simplywallst/ui-core/icons/BoardMembersOutline';
import ExecutiveOutline from '@simplywallst/ui-core/icons/ExecutiveOutline';
import { Role } from './styled';

interface Props {
  boardTitle?: string;
  teamTitle?: string;
}

const RolesWithTitles = ({ teamTitle, boardTitle }: Props) => {
  return (
    <>
      {teamTitle && (
        <Role>
          <ExecutiveOutline /> {teamTitle}
        </Role>
      )}
      {boardTitle && (
        <Role>
          <BoardMembersOutline /> {boardTitle}
        </Role>
      )}
    </>
  );
};

export default RolesWithTitles;
